import {EdgeProps} from 'reactflow';

import {
  DataFlowEdgeForValidation,
  ProcessFlowchartForValidation,
} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcessFlowchartEdgeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {EdgeStatus} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeV2Constants';

export function getEdgeStatus(props: EdgeProps): EdgeStatus | undefined {
  return props.data?.validationErrors?.length > 0 ? 'error' : undefined;
}

export function hasMatchingControlFlowEdge(
  edge: DataFlowEdgeForValidation,
  flowchart: ProcessFlowchartForValidation
): boolean {
  return flowchart.edges.some(
    (e) =>
      e.type === ProcessFlowchartEdgeType.CONTROL_FLOW && e.target === edge.target && e.source === edge.source
  );
}
